import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { AboutTimeline } from '../AboutTimeline';
import Members from './Members';
import { membersData } from '../Membersdata';
import SpecialThanks from '../SpecialThanks';
import Navbar from '../header/Navbar';
import koalaBg from '../../assets/Koala/11.jpg';
import app1 from "../../assets/ICON/1.png";
import app2 from "../../assets/ICON/39.png";
import app3 from "../../assets/ICON/17.png";
import app4 from "../../assets/ICON/19.png";
import Mission_and_vision from "../Mission_and_vision";
import leaf from '../../assets/HomePage/aboutus/flower1.svg';
import leaf1 from '../../assets/HomePage/aboutus/flower2.svg';
import leaf2 from '../../assets/HomePage/aboutus/flower3.svg';
import leaf3 from '../../assets/HomePage/aboutus/leaf1.svg';
import leaf4 from '../../assets/HomePage/aboutus/flower4.svg';
import InfoLeaflet from './InfoLeaflet';

// Main timeline page component
const AboutUs = () => {
  const location = useLocation();
  const [isLoaded, setIsLoaded] = useState(false);
  const [sectionsVisible, setSectionsVisible] = useState({
    hero: false,
    mission: false,
    timeline: false,
    specialThanks: false,
    members: false,
    footer: false
  });

  // Handle page load animation
  useEffect(() => {
    setIsLoaded(true);

    // Sequential animation of sections with fixed timing and order
    const timeouts = [
      setTimeout(() => setSectionsVisible(prev => ({ ...prev, hero: true })), 100),
      setTimeout(() => setSectionsVisible(prev => ({ ...prev, mission: true })), 300),
      setTimeout(() => setSectionsVisible(prev => ({ ...prev, timeline: true })), 600),
      setTimeout(() => setSectionsVisible(prev => ({ ...prev, specialThanks: true })), 900),
      setTimeout(() => setSectionsVisible(prev => ({ ...prev, members: true })), 1200),
      setTimeout(() => setSectionsVisible(prev => ({ ...prev, footer: true })), 1500),
    ];

    return () => timeouts.forEach(clearTimeout);
  }, []);

  // Handle auto-scroll to AboutTimeline when navigated from AboutUs
  useEffect(() => {
    if (location.state?.scrollTo === 'about-timeline') {
      setTimeout(() => {
        const timelineElement = document.getElementById('about-timeline');
        if (timelineElement) {
          timelineElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }, 1000);
    }
  }, [location.state]);

  return (
    <div id="about-us" className={`transition-opacity duration-1000 ${isLoaded ? 'opacity-100' : 'opacity-0'}`}>
      {/* Hero Section with fade-in animation */}
      <section
        className={`relative bg-center bg-backgroundAlt text-white bg-blend-dark overflow-hidden
                   transform transition-all duration-1000 ease-out
                   ${sectionsVisible.hero ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'}`}
        style={{
          backgroundImage: `url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAAPUlEQVQIW2NkgALtmsTNV1tm+zKCBHQqUjez3HpszKhTnbL5D+MfBparz4yvrN8pBVZhEOT17MK6bVIgNgBUvBO1R5/vswAAAABJRU5ErkJggg=="),url(${koalaBg})`,
          backgroundRepeat: 'repeat, no-repeat',
          backgroundSize: 'auto, cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'scroll',
        }}
      >
        <div className="relative px-4 mx-auto max-w-screen-xl text-center 
                  py-10 sm:py-16 lg:py-32 
                  flex flex-col justify-center items-center 
                  min-h-[300px] sm:min-h-[400px] md:min-h-[500px]">

          {/* Sub Title with slide-up animation */}
          <p className={`mb-2 text-lg font-normal text-background lg:text-xl
                        transform transition-all duration-700 delay-200
                        ${sectionsVisible.hero ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'}`}>
            About us
          </p>

          {/* Title with slide-up animation */}
          <h1 className={`mb-4 text-4xl font-extrabold leading-none text-white md:text-6xl lg:text-8xl [text-shadow:_7px_3px_0px_#3D8D7A]
                         transform transition-all duration-700 delay-400
                         ${sectionsVisible.hero ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'}`}>
            Who we are
          </h1>
        </div>
      </section>

      {/* Main Content with unified color flow */}
      <div>
        {/* Mission Section with light green background */}
        <section className={`px-4 py-8 bg-gradient-to-b
                           transform transition-all duration-700 ease-out
                           ${sectionsVisible.mission ? 'translate-y-0 opacity-100' : 'translate-y-12 opacity-0'}`}>
          <Mission_and_vision />

          {/* Koala Mission Divider */}
          <div className={`w-full max-w-[1400px] mx-auto my-12 flex items-center justify-center
                          transform transition-all duration-500 delay-300
                          ${sectionsVisible.mission ? 'scale-100 opacity-100' : 'scale-95 opacity-0'}`}>

            {/* Left side with sleeping koala */}
            <div className="flex items-center space-x-2">
              <img src={app2} alt="Koala" className="w-20 h-20 scale-x-[-1] animate-pulse" />
              <img src={leaf1} alt="Pink Flower" className="w-6 h-6 transform rotate-12 animate-pulse" style={{ animationDelay: '0.5s' }} />
              <div className="flex-grow h-px bg-gradient-to-r from-green-300 to-green-400 w-20"></div>
            </div>

            {/* Center decorative element */}
            <div className="mx-6 flex flex-col items-center group cursor-pointer">
              <div className="flex items-center space-x-1 mb-1">
                <img src={leaf4} alt="Purple Flower" className="w-5 h-5 transform -rotate-45 transition-transform duration-300 group-hover:rotate-0 animate-bounce" />
                <div className="w-3 h-3 rounded-full bg-amber-500 animate-ping"></div>
                <img src={leaf4} alt="Purple Flower" className="w-5 h-5 transform rotate-45 transition-transform duration-300 group-hover:rotate-0 animate-bounce" style={{ animationDelay: '0.3s' }} />
              </div>
              <div className="text-xs text-gray-500 font-light">Our Journey</div>
            </div>

            {/* Right side with climbing koala - mirrored */}
            <div className="flex items-center space-x-2">
              <div className="flex-grow h-px bg-gradient-to-l from-green-300 to-green-400 w-20"></div>
              <img src={leaf1} alt="Pink Flower" className="w-6 h-6 transform -rotate-12 animate-pulse" style={{ animationDelay: '0.5s' }} />
              <img src={app2} alt="Koala" className="w-20 h-20 animate-pulse" style={{ animationDelay: '1s' }} />
            </div>
          </div>
        </section>

        {/* Timeline Section with consistent light green tone */}
        <section className={`py-8 transform transition-all duration-700 ease-out delay-200
                           ${sectionsVisible.timeline ? 'translate-y-0 opacity-100' : 'translate-y-12 opacity-0'}`}>
          <div id="about-timeline" className="scroll-smooth">
            <InfoLeaflet />
          </div>
        </section>


        {/* Smooth transition area from Timeline to Special Thanks */}
        {/*
        <div className="bg-gradient-to-b from-[#f1f7e4] via-[#eef5e0] to-[#ebf3dc] py-8">
        </div>*/}

        {/* Special Thanks Section with slightly deeper green tone */}
        {/*
        <section className={`bg-gradient-to-b from-[#ebf3dc] to-[#e6f0d6]
                           transform transition-all duration-700 ease-out delay-300
                           ${sectionsVisible.specialThanks ? 'translate-y-0 opacity-100' : 'translate-y-12 opacity-0'}`}>
          <SpecialThanks />
        </section>*/}

        {/* Smooth transition from Special Thanks to Team */}
        <div className="bg-gradient-to-b from-[#e6f0d6] via-[#e2edce] to-[#dde9c6] py-12">
          {/* Meet Our Team decorator improved version */}
          <div className={`w-full flex justify-center transform transition-all duration-700 ease-out delay-400
                          ${sectionsVisible.specialThanks ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'}`}>
            <div className="flex items-center justify-center w-full max-w-4xl px-8">

              {/* Left decorative line with flowers and leaves */}
              <div className="flex-1 flex items-center justify-end pr-8">
                <div className="w-full h-px bg-gradient-to-r from-transparent via-green-400 to-green-500"></div>
                <img src={leaf3} alt="Leaf" className="ml-2 w-8 h-8 transform -rotate-12 animate-bounce" />
                <img src={leaf4} alt="Purple Flower" className="ml-1 w-6 h-6 transform rotate-45 animate-pulse" style={{ animationDelay: '0.2s' }} />
              </div>

              {/* Center koala with symmetric floral branch */}
              <div className="flex flex-col items-center px-6 group cursor-pointer">
                {/* Main koala with hover animation */}
                <div className="mb-2 transform transition-all duration-300 group-hover:scale-110 group-hover:rotate-12 animate-pulse">
                  <img src={app1} alt="Koala" className="w-20 h-20 sm:w-24 sm:h-24" />
                </div>

                {/* Symmetric floral branch */}
                <div className="flex items-center space-x-1 transform transition-all duration-300 group-hover:scale-105">
                  <img src={leaf1} alt="Pink Flower" className="w-4 h-4 transform -rotate-12 animate-bounce" style={{ animationDelay: '0.1s' }} />
                  <div className="w-8 h-0.5 bg-amber-600 rounded-full"></div>
                  <img src={leaf1} alt="Pink Flower" className="w-4 h-4 transform rotate-12 animate-bounce" style={{ animationDelay: '0.3s' }} />
                </div>

                {/* Text */}
                <p className="text-sm text-gray-700 mt-2 font-medium tracking-wide opacity-80 group-hover:opacity-100 transition-opacity duration-300">
                  Meet Our Team
                </p>
              </div>

              {/* Right decorative line with flowers and leaves - mirrored */}
              <div className="flex-1 flex items-center justify-start pl-8">
                <img src={leaf4} alt="Purple Flower" className="mr-1 w-6 h-6 transform -rotate-45 animate-pulse" style={{ animationDelay: '0.2s' }} />
                <img src={leaf3} alt="Leaf" className="mr-2 w-8 h-8 transform rotate-12 animate-bounce" />
                <div className="w-full h-px bg-gradient-to-l from-transparent via-green-400 to-green-500"></div>
              </div>
            </div>
          </div>
        </div>

        {/* Members Section with relatively light green tone */}
        <div className={`w-full flex justify-center px-4 
                        bg-gradient-to-b from-[#dde9c6] via-[#dae7c3] to-[#d7e4c0]
                        transform transition-all duration-700 ease-out delay-500
                        ${sectionsVisible.members ? 'translate-y-0 opacity-100' : 'translate-y-12 opacity-0'}`}>
          <div className="max-w-6xl w-full">
            {/* Spacer with koala family decoration */}
            <div className="py-8 flex justify-center">
              <div className="flex items-center space-x-4">
                {/* Baby koala */}
                <img src={app3} alt="Baby Koala" className="w-12 h-12 opacity-70 animate-bounce" style={{ animationDelay: '0.2s' }} />
                {/* Mama koala */}
                <img src={app4} alt="Mama Koala" className="w-12 h-12 animate-pulse" />
                {/* Papa koala */}
                <img src={app3} alt="Papa Koala" className="w-12 h-12 scale-x-[-1] opacity-80 animate-bounce" style={{ animationDelay: '0.8s' }} />
              </div>
            </div>

            {/* Members component wrapper */}
            <div className="relative group pb-16">
              {/* Decorative corner koalas */}
              <div className="absolute -top-4 -left-4 opacity-30 transform -rotate-12 transition-all duration-300 group-hover:opacity-60 group-hover:scale-110 z-20">
                <img src={app1} alt="Corner Koala" className="w-8 h-8" />
              </div>
              <div className="absolute -top-4 -right-4 opacity-30 transform rotate-12 transition-all duration-300 group-hover:opacity-60 group-hover:scale-110 z-20">
                <img src={app1} alt="Corner Koala" className="w-8 h-8" />
              </div>

              {/* Symmetric floral and leaf border decoration */}
              {/* Top corners - symmetric */}
              <img src={leaf1} alt="Pink Flower" className="absolute top-0 left-1/4 w-6 h-6 opacity-40 transform -rotate-45 animate-pulse" style={{ animationDelay: '0.5s' }} />
              <img src={leaf1} alt="Pink Flower" className="absolute top-0 right-1/4 w-6 h-6 opacity-40 transform rotate-45 animate-pulse" style={{ animationDelay: '0.5s' }} />

              {/* Bottom corners - symmetric */}
              <img src={leaf4} alt="Purple Flower" className="absolute bottom-4 left-1/3 w-5 h-5 opacity-50 transform rotate-12 animate-bounce" style={{ animationDelay: '1s' }} />
              <img src={leaf4} alt="Purple Flower" className="absolute bottom-4 right-1/3 w-5 h-5 opacity-50 transform -rotate-12 animate-bounce" style={{ animationDelay: '1s' }} />

              {/* Side decorations - symmetric */}
              <img src={leaf3} alt="Leaf" className="absolute top-1/2 left-8 w-4 h-4 opacity-30 transform rotate-45 animate-pulse" style={{ animationDelay: '1.5s' }} />
              <img src={leaf3} alt="Leaf" className="absolute top-1/2 right-8 w-4 h-4 opacity-30 transform -rotate-45 animate-pulse" style={{ animationDelay: '1.5s' }} />

              {/* Members component */}
              <div className="relative z-10 transition-transform duration-300 group-hover:scale-[1.02]">
                <Members cards={membersData} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;